<template>
  <!-- 「group」として親のオブジェクトを受け取り、親子全てをフラットな配列にしてselectに表示する。 子はその親からインデントされて表示される。 -->
  <v-select
    class="purple-input"
    :outline="outline"
    :light="light"
    :box="box"
    :value="value"
    :label="label"
    :rules="rules"
    :items="options"
    :item-disabled="item => item.disabled"
    @change="change($event)"
  >
    <template v-slot:item="{ item }">
      <option
        :value="item.value"
        :style="{
          'padding-left': `${ item.level }rem`,
        }"
      >
        {{ item.text }}
      </option>
    </template>
  </v-select>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: () => null
    },
    label: {
      type: String,
      default: 'エリア'
    },
    group: {
      type: Object,
      default: () => null
    },
    rules: {
      type: Array,
      default: () => []
    },
    disableCompany: {
      type: Boolean,
      default: false
    },
    disableArea: {
      type: Boolean,
      default: false
    },
    disableItem: {
      type: Function,
      default: () => false
    },
    outline: {
      type: Boolean,
      default: () => false
    },
    light: {
      type: Boolean,
      default: () => false
    },
    box: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    options () {
      return this.flatten(this.group)
    }
  },
  methods: {
    /**
     * @param {{id: Number, name: String, children: [*]}} groups 親となるグループ
     * @param {Number} [level=0] 階層（インデント幅）
     */
    flatten (groups, level = 0) {
      if (groups == null) {
        return []
      }
      if (groups.length == null) {
        groups = [groups]
      }

      const list = []

      for (const group of groups) {
        if (group.type === 'area' && this.disableArea) {
          continue
        }
        const disabled = (group.type === 'company' || group.type === 'main_company') && this.disableCompany
        list.push({
          text: group.name,
          value: group.id,
          level,
          disabled: disabled || this.disableItem(group)
        })
        list.push(...this.flatten(group.children, level + 1))
      }

      return list
    },
    change (value) {
      const n = parseInt(value, 10)
      if (isNaN(n)) {
        this.$emit('input', null)
      } else {
        this.$emit('input', n)
      }
    }
  }
}
</script>
